const API = process.env.REACT_APP_BACKEND_URL + "/api";

const LEAD_STATUSES = [
  { id: "new_lead", label: "New Lead", color: "bg-blue-500" },
  { id: "contacted", label: "Contacted", color: "bg-yellow-500" },
  { id: "trial_scheduled", label: "Trial Scheduled", color: "bg-purple-500" },
  { id: "joined", label: "Joined", color: "bg-green-500" },
  { id: "not_qualified", label: "Not Qualified", color: "bg-gray-400" },
  { id: "lost", label: "Lost", color: "bg-red-500" },
];

export { API, LEAD_STATUSES };
